// extracted by mini-css-extract-plugin
export default {"OuterContainer":"Layout_OuterContainer__xUShy","Body":"Layout_Body__0gz--"};